var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgProfileVouchers = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 28 28",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M11.856 21.668c.415.414 1.056.445 1.432.069l8.449-8.45c.376-.375.345-1.016-.07-1.43l-1.38-1.382c-.717.387-1.679.238-2.34-.423-.66-.66-.81-1.622-.422-2.339l-1.381-1.38c-.415-.415-1.056-.446-1.432-.07l-8.449 8.45c-.376.375-.345 1.016.07 1.43l1.377 1.379c.718-.397 1.688-.25 2.353.415.664.665.812 1.635.415 2.353l1.378 1.378Z",
  stroke: "#000",
  strokeWidth: 1.143,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
export default SvgProfileVouchers;